<template>
  <form
    class="search-input-component form-group mb-0"
    role="search"
    action=""
    method="get"
  >
    <div class="input-group">
      <input
        :value="query"
        type="text"
        name="query"
        class="search-input form-control border-0"
        :placeholder="placeholder"
        @input="onInput"
      />
      <button
        v-show="!!query"
        class="input-group-text border-0 bg-white"
        @click.prevent="$emit('reset')"
      >
        <IconClose />
      </button>
      <button type="submit" class="input-group-text border-0 bg-white">
        <IconSearch />
      </button>
    </div>
  </form>
</template>

<script>
import IconSearch from '../../../../templates/icons/search.svg';
import IconClose from '../../../../templates/icons/close.svg';

export default {
  components: {
    IconSearch,
    IconClose,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Search...',
    },
  },
  data() {
    return {
      query: this.value,
    };
  },
  watch: {
    value(newVal) {
      if (newVal !== this.query) {
        this.query = newVal;
      }
    },
  },
  methods: {
    onInput($event) {
      this.query = $event.target.value;
      this.$emit('input', $event.target.value);
    },
  },
};
</script>
